import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';

// material
import { Box, Container, Typography } from '@mui/material';

// components
import Page from '../../components/Page';

// api
import tracker from '../../api/tracker';
import ResourceForm from '../../sections/@dashboard/resources/ResourceForm';

// ---------------------------------------------------------------------

export default function SaveResource() {
  const { resourceid } = useParams();
  const { t } = useTranslation();
  const [resourceData, setResourceData] = useState(null);
  const [isLoading, setIsLoading] = useState(!!resourceid);

  const fetchResourceData = async () => {
    setIsLoading(true);
    const response = await tracker.get(`resources/${resourceid}`);
    setResourceData(response.data.data);
    setIsLoading(false);
  };

  useEffect(() => {
    if (resourceid) {
      fetchResourceData();
    }
  }, []);

  return (
    <Page title={t('Resource_form')}>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom mb={4}>
          {resourceid ? t('Update_resource') : t('New_resource')}
        </Typography>
        <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
          {isLoading ? (
            <FadeLoader color="blue" loading={isLoading} cssOverride={{ margin: '0 auto' }} size={50} />
          ) : (
            <ResourceForm resourceData={resourceData} />
          )}
        </Box>
      </Container>
    </Page>
  );
}
